<template>
  <div class="card mb-2">
    <div
      class="card-content"
      @click="toggle"
    >
      <div class="media">
        <div class="media-content">
          <p class="title">{{ supplier.name }}</p>
          <p class="subtitle">{{ supplier.city }}</p>
        </div>
      </div>

      <div
        v-show="expanded"
        class="content"
      >
        <p>
          {{ supplier.address }}<br />
          {{ supplier.zip }}<br />
          {{ supplier.city }}<br />
          {{ supplier.country }}<br />
        </p>
      </div>
    </div>

    <div v-if="expanded" class="card-footer">
      <a class="card-footer-item" :href="'mailto:' + supplier.email ">{{ supplier.email }}</a>
      <a class="card-footer-item" :href="'tel:' + supplier.phone ">{{ supplier.phone }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Producer',

  props: {
    supplier: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      expanded: false
    }
  },

  methods: {
    toggle () {
      this.expanded = !this.expanded
    }
  }
}
</script>

<style scoped>

</style>
